<template>
  <div>
    <h1>Audio Demo</h1>
    <textarea v-model="speechText" :placeholder="placeholder" cols="100" rows="10" />
    <br />
    <select v-on:change="doThis" ref="voiceSelect">
      <option v-for="(option, index) in voiceOptions" :key="index" :value="option.title" :index="index">{{option.title}}</option>
    </select>
    <button v-on:click="readText">Read</button>
  </div>
</template>

<script>
  import browserSpeak from 'browser-speak'
  export default {
    data() {
      return {
        speechText: 'Enter text here...',
        placeholder: 'Enter text here...',
        voiceOptions: [],
        voiceIndex: 0
      }
    },
    methods: {
      doThis() {
        let queryValue = this.$refs.voiceSelect.value
        this.voiceIndex = document.querySelector(`option[value='${queryValue}']`).index
      },
      readText() {
        browserSpeak(this.speechText, this.voiceIndex)
      }
    },
    mounted() {

      const populateVoices = () => {
        let voices = window.speechSynthesis.getVoices()
        for (let i = 0; i < voices.length; i++) {
          this.voiceOptions.push({
            title: `${voices[i].name} - ${voices[i].lang}`,
            index: i
          })
        }
      }

      let pollForVoices = setInterval(() => {
        if (!this.voiceOptions.length) {
          populateVoices()
        } else {
          clearInterval(pollForVoices)
        }
      }, 150)

    }
  }

</script>

<style scoped lang="scss">
  div {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// audio.vue?9329e268